import React from "react";
import Button from "../../presenters/button";

const Disclaimer = () => {
    return (
        <>
            <div>

            </div>
            <div className="Disclaimer">
                <div className="Disclaimer__separator"></div>
                <div className="container" style={{ height: "100%" }}>
                    <div className="row" style={{ height: "100%" }}>
                        <div className="Disclaimer__text-container">
                            <p className="Disclaimer__text-paragraph container">
                                As informa&ccedil;&otilde;es apresentadas neste recurso (&quot;Simulador&quot;) s&atilde;o meramente
                                ilustrativas e baseadas em dados te&oacute;ricos a partir de cotas de fundos e &iacute;ndices de
                                mercado dispon&iacute;veis publicamente. As informa&ccedil;&otilde;es presentes neste material
                                t&eacute;cnico s&atilde;o baseadas em simula&ccedil;&otilde;es e os resultados reais poder&atilde;o ser
                                significativamente diferentes. Rentabilidade obtida no passado n&atilde;o representa
                                garantia de resultados futuros. A rentabilidade divulgada n&atilde;o &eacute; l&iacute;quida de
                                impostos. O investimento em Fundo n&atilde;o &eacute; garantido pelo Fundo Garantidor de
                                Cr&eacute;dito - FGC. A Pandhora n&atilde;o comercializa ou distribui quotas de fundos de
                                investimento, portanto todas as informa&ccedil;&otilde;es contidas neste website n&atilde;o devem
                                ser consideradas como oferta de venda de cotas de fundos de investimentos ou
                                de qualquer t&iacute;tulo ou valor mobili&agrave;rio, recomenda&ccedil;&atilde;o de investimento e nem
                                devem servir como &uacute;nica base para tomada de decis&otilde;es de investimento. A
                                Pandhora Investimentos se exime de qualquer responsabilidade, direta ou indireta,
                                por todos e quaisquer preju&iacute;zos decorrentes de opera&ccedil;&otilde;es realizadas com base
                                nas informa&ccedil;&otilde;es aqui prestadas, notadamente relacionadas &agrave; decis&atilde;o de
                                investimento do cliente.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="DisclaimerCTA">
                <div className="container" style={{ height: "100%" }}>
                    <div className="row" style={{ height: "100%" }}>
                        <div className="col-xl-8">
                            <div className="DisclaimerCTA__title-container container">
                                <p> <span style={{ color: "white", fontWeight: 600 }}>Conheça nossos fundos</span> <br />
                                    <b> e revolucione </b> seus investimentos.
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="DisclaimerCTA__button-container">
                                <a href="https://investindobem.com/app/#/signin">
                                    <Button className="DisclaimerCTA__button" color="black">
                                        Invista agora
                                    </Button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default Disclaimer;
